module.exports = __webpack_public_path__ + "static/media/notification-sound.10244a0e.mp3";